import { useCallback, useRef } from "react";
import shopBurst from "../../assets/img/shop-burst.png";
import { useModalMotion } from "../../hooks/useModalMotion";

/**
 * “Are you still there?” — same card language as QuitLeaveModal.
 */
function IdleScreenTimeModal({ show, onContinue, onQuit }) {
  const actionRef = useRef(null);
  const finish = useCallback(() => {
    const action = actionRef.current;
    actionRef.current = null;
    action?.();
  }, []);
  const { requestClose, motionClassName } = useModalMotion(finish, {
    open: show,
  });

  const runThenClose = (action) => {
    actionRef.current = action;
    requestClose();
  };

  if (!show) return null;

  return (
    <div
      className={`quitLeave idleModal${motionClassName}`}
      role="dialog"
      aria-modal="true"
      aria-labelledby="idleTitle"
    >
      <button
        type="button"
        className="quitLeave__backdrop"
        onClick={() => runThenClose(onContinue)}
        aria-label="Stay and continue"
      />
      <div className="quitLeave__card">
        <div className="quitLeave__titleRow">
          <img
            className="quitLeave__burst quitLeave__burst--left"
            src={shopBurst}
            alt=""
            aria-hidden="true"
          />
          <h2 id="idleTitle" className="quitLeave__title">
            Are you still there?
          </h2>
          <img
            className="quitLeave__burst"
            src={shopBurst}
            alt=""
            aria-hidden="true"
          />
        </div>
        <p className="quitLeave__copy">
          Your session is about to expire due to inactivity. Continue now to
          keep going.
        </p>
        <div className="quitLeave__actions">
          <button
            type="button"
            className="quitLeave__stay"
            onClick={() => runThenClose(onContinue)}
          >
            Stay &amp; continue
          </button>
          <button
            type="button"
            className="quitLeave__leave"
            onClick={() => runThenClose(onQuit)}
          >
            Quit
          </button>
        </div>
      </div>
    </div>
  );
}

export default IdleScreenTimeModal;
